<input
	[name]="'input' + name"
	type="checkbox"
	class="form-control"
	[ngModel]="model"
	[ngClass]="classes() + (icon ? ' has-image' : '')"
	readonly
	inert
/>
<label *ngIf="icon" for="input{{name}}" [ngClass]="classes()"><bi [ngClass]="{ 'checked': model, 'unchecked': !model }" name="{{icon}}"></bi></label>
